import React, { useState } from "react";
import Header from "./header";
import "./layout.css";
import Realtime from "./realtime";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Radar1 from "./radar1";
import Radar2 from "./radar2";
import Radar3 from "./radar3";
import Radar4 from "./radar4";
import makeDate from "../chart/makeDate";
import makeDate2 from "../chart/makeDate2";
import Chart from "../chart/chart";
import ChartMid from "../chart/chartMid";
import ChartLong from "../chart/chartLong";
import useInterval from "./interval";

const Layout = () => {
  const [chartData, setChartData] = useState([]);
  const [chartDataMid, setChartDataMid] = useState([]);
  const [chartDataLong, setChartDataLong] = useState([]);
  const chartDay = makeDate(chartData);
  const chartDayMid = makeDate(chartDataMid);
  const chartDayLong = makeDate2(chartDataLong);

  React.useEffect(() => {
    fetch("http://222.239.231.149:8080/dashboard/yeongam/data/windData.json")
      .then((res) => res.json())
      .then((data) => {
        setChartData(data);
      });
  }, []);
  useInterval(() => {
    fetch("http://222.239.231.149:8080/dashboard/yeongam/data/windData.json")
      .then((res) => res.json())
      .then((data) => {
        setChartData(data);
      });
  }, 60000);

  React.useEffect(() => {
    fetch("http://222.239.231.149:8080/dashboard/yeongam/data/windDataMid.json")
      .then((res) => res.json())
      .then((data) => {
        setChartDataMid(data);
      });
  }, []);
  useInterval(() => {
    fetch("http://222.239.231.149:8080/dashboard/yeongam/data/windDataMid.json")
      .then((res) => res.json())
      .then((data) => {
        setChartDataMid(data);
      });
  }, 60000);

  React.useEffect(() => {
    fetch(
      "http://222.239.231.149:8080/dashboard/yeongam/data/windDataLong.json"
    )
      .then((res) => res.json())
      .then((data) => {
        setChartDataLong(data);
      });
  }, []);
  useInterval(() => {
    fetch(
      "http://222.239.231.149:8080/dashboard/yeongam/data/windDataLong.json"
    )
      .then((res) => res.json())
      .then((data) => {
        setChartDataLong(data);
      });
  }, 60000);

  return (
    <div className="layout">
      <Header />
      <div className="cen">
        <div className="set1">
          <Realtime />
          <article className="graph1">
            <Chart chartDay={chartDay} />
          </article>
        </div>
        <div className="set2">
          <Radar1 />
          <Radar2 />
          <article className="graph2">
            <ChartMid chartDayMid={chartDayMid} />
          </article>
        </div>
        <div className="set3">
          <Radar3 />
          <Radar4 />
          <article className="graph3">
            <ChartLong chartDayLong={chartDayLong} />
          </article>
        </div>
      </div>

      {/* 모바일 레이아웃 */}
      <div className="mCen">
        <div className="mset1">
          <Realtime />
        </div>
        <article className="mgraph1">
          <Chart chartDay={chartDay} />
        </article>
        <article className="mgraph2">
          <ChartMid chartDayMid={chartDayMid} />
        </article>
        <article className="mgraph3">
          <ChartLong chartDayLong={chartDayLong} />
        </article>
        <div className="mset2">
          <div>
            <Radar1 />
            <Radar2 />
          </div>
          <div>
            <Radar3 />
            <Radar4 />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
